
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const promoVideoSrc = `${process.env.PUBLIC_URL}/Video%20divulga%C3%A7%C3%A3o2.mp4`;

const About = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [videoRef, videoVisible] = useScrollAnimation();

  return (
    <section id="sobre" className="py-5 bg-white">
      <div className="container mx-auto px-2">
        <div className="max-w-6xl mx-auto">
          <h2 
            ref={titleRef}
            className={`text-4xl font-bold text-center text-gray-800 mb-4 ${titleVisible ? 'animate-on-scroll' : 'opacity-0'}`}
          >
            Sobre o curso online
          </h2>
          
          <div 
            ref={videoRef}
            className={`mb-12 ${videoVisible ? 'animate-on-scroll' : 'opacity-0'}`}
            style={{ animationDelay: '0.2s' }}
          >
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <video
                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-xl"
                src={promoVideoSrc}
                autoPlay
                muted
                playsInline
                controls
                preload="auto"
              >
                Seu navegador não suporta reprodução de vídeo.
              </video>
            </div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="text-orange-500 mb-4">
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Aprenda Rápido</h3>
              <p className="text-gray-700">
                Com nosso curso online você aprenderá de forma rápida e resumida tudo sobre 
                instalações e reparos elétricos residenciais.
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="text-orange-500 mb-4">
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Flexibilidade Total</h3>
              <p className="text-gray-700">
                Podendo assistir e rever quando quiser e de onde estiver. 
                Acesso vitalício ao conteúdo.
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="text-orange-500 mb-4">
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Direto ao Ponto</h3>
              <p className="text-gray-700">
                Sem enrolação! Irei direto ao ponto para poupar o seu tempo e focar 
                no mais importante (seu aprendizado).
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="text-orange-500 mb-4">
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"></path>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Aulas em Vídeo</h3>
              <p className="text-gray-700">
                Conteúdo em vídeo de alta qualidade com demonstrações práticas 
                e explicações detalhadas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
